export default {
  device: {
    checkLoading: '正在检测....',
    check: '检测',
    checkTitle: '设备检测',
    checkResult: '检测结果',
    checkItem: '检测项目',
    checkSuccess: '项目检测正常'
  },
  hybird: {
    id: 'ID',
    status: '激活状态',
    userName: '用户',
    companyName: '公司',
    companyId: '公司id',
    activeCode: '激活码',
    createdTime: '创建时间',
    searchPlaceholder: '用户名或公司名',
    active: '已激活',
    unActive: '未激活'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/zh_cn/v6.js